import styled from 'styled-components';
import { Flex } from 'ui';

export const AuthProviderWrapper = styled(Flex)`
  height: 100vh;
  background: #242424;
`;
